// extracted by mini-css-extract-plugin
export default {"wrapper":"PropDescription_wrapper__Zim3d"};